/** HTML shown in react-tooltip v5 for password requirement hints (see data-tooltip-html). */
export const PASSWORD_REQUIREMENTS_TOOLTIP_HTML =
  "<div>Password requirements:<ol><li>Minimum 12 characters</li><li>At least one uppercase letter</li><li>At least one lowercase letter</li><li>At least one special character</li><li>At least one numercial digit</li></ol></div>";

export const PASSWORD_REQUIREMENTS_TOOLTIP_ID = "password-requirements";
